
    import Vue from 'vue';
    import CUPEService from '@/apps/shared/services/cupe-service';
    import MailService from '@/apps/shared/services/email-service';
    import CRMCotizadorWebService from '@/apps/shared/services/crm-service';
    import FilePathService from '@/apps/shared/services/filePath-service';
    export default Vue.extend({
        components: {
        },
        name: 'UrbanMobilityFinalPayment',
        data() {
            return {
                externalIdentifier: null,
                HomeRoot: null,
                leadId: null,
            }
        },
        methods: {
            changeTitleAndIcon() {
                // Lógica para determinar el nuevo título
                const newTitle = 'Movilidad urbana';

                // Emite eventos para actualizar el título
                this.$emit('updateTitle', newTitle);
            },
            updateByProductGoogleAnalytics() {
                window.globalThis.dataLayer = window.globalThis.dataLayer || [];
                const productGtmName = 'DefaultUrbanMobilityGTMInfo';
                this.$emit('updateByProductGoogleAnalytics', productGtmName);
            },
            getFilePath() {
                sessionStorage.setItem("ExitOrContinueModal", "false");
                FilePathService.getFilePath("UrlBase")
                    .then(response => {
                        window.location.href = response + "movilidad";
                    });
            },
            getMailValues() {
                var clientData = JSON.parse(sessionStorage.getItem("stepOneData"));
                var nombreCliente = clientData.firstName.toLowerCase().split(' ')
                var firstName = nombreCliente[0].charAt(0).toUpperCase() + nombreCliente[0].substring(1);
                var planData = JSON.parse(sessionStorage.getItem("PlanSelected"));
                var vehicleData = JSON.parse(sessionStorage.getItem("DataVehicle"));
                var effectDate = new Date();
                var vigencyDate = new Date();
                vigencyDate.setFullYear(vigencyDate.getFullYear() + 1);

                var mailValues = JSON.stringify({
                    parameters: [
                        {
                            name: "@ReportCode",
                            value: "26"
                        },
                        {
                            name: "@contratante",
                            value: firstName.toString()
                        },
                        {
                            name: "@nombrePlan",
                            value: planData.planDescription.toString()
                        },
                        {
                            name: "@vigenciaDesde",
                            value: (effectDate.getDate() + '/' + (effectDate.getMonth() + 1) + '/' + effectDate.getFullYear())
                        },
                        {
                            name: "@vigenciaHasta",
                            value: (vigencyDate.getDate() + '/' + (vigencyDate.getMonth() + 1) + '/' + vigencyDate.getFullYear())
                        },
                        {
                            name: "@costoMensual",
                            value: planData.premioMensual
                        },
                        {
                            name: "@vehicleSelected",
                            value: vehicleData.vehTypeDescription.toString()
                        },
                        {
                            name: "@vehicleBrand",
                            value: vehicleData.vehicleBrand.toString()
                        },
                        {
                            name: "@sumaAsegurada",
                            value: planData.groupOfAmparoTheftOptions[0].capital.toString()
                        }
                    ],
                    to: clientData.email,
                    from: "cotizador@sancorseguros.com",
                    productId: 936
                });
                return mailValues;
            },
        },
        mounted() {
            this.changeTitleAndIcon();
            this.updateByProductGoogleAnalytics();
            sessionStorage.setItem("ExitOrContinueModal", "true");
            window.globalThis.dataLayer = window.globalThis.dataLayer || [];
            this.leadId = JSON.parse(sessionStorage.getItem("LeadId"));
            this.externalIdentifier = sessionStorage.getItem("PricingId");
            var planData = JSON.parse(sessionStorage.getItem("PlanSelected"));
            var clientData = JSON.parse(sessionStorage.getItem("stepOneData"));
            var FormattedPremioMensual = planData.premioMensual.toString().includes(".") ? planData.premioMensual.toString().replaceAll('.', '') : planData.premioMensual;
            window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'cotizador-movilidad-venta-completa', 'value': FormattedPremioMensual });


            //--------------LLAMADA AL ADDFINISHEDQUOTATION DE CRM---------------------
            var premioMensual = Number.isInteger(planData.premioMensual) ? planData.premioMensual : parseInt(planData.premioMensual.replaceAll(".", ""));
            var localidad = clientData.address;
            var ramo = "Movilidad";

            CUPEService.Finish(parseInt(this.externalIdentifier), 936, clientData.lastName, clientData.documentNumber, localidad, clientData.email, clientData.firstName, planData.PricingId[0].toString(), premioMensual, planData.planDescription.toString(), ramo, clientData.areaCode, clientData.telephone).then(FinishResult => {
                if (FinishResult) {
                    CRMCotizadorWebService.CreateOrEditLead(this.leadId, null, location.href, null, null, 936, true, "7", null, null, null);
                    //ENVIO DE EMAIL
                    NF.UI.Page.block();
                    MailService.sendMail(this.getMailValues()).then(response => {
                        if (response.result) {
                            NF.Notification.show({
                                type: NF.Notification.Type.SUCCESS,
                                title: 'Mail Enviado',
                                content: 'Mail enviado exitosamente.',
                                position: NF.Notification.Positions.TOP_RIGHT,
                                clickClose: true,
                                autoHideDelay: 10000,
                            });
                            NF.UI.Page.unblock();
                        } else if (response.result == false) {
                            NF.Notification.show({
                                type: NF.Notification.Type.ERROR,
                                title: 'Error',
                                content: 'Se produjo un error inesperado.',
                                position: NF.Notification.Positions.TOP_RIGHT,
                                clickClose: true,
                                autoHideDelay: 10000,
                            });
                            NF.UI.Page.unblock();
                        } else {
                            NF.UI.Page.unblock();
                        }
                    });
                }
                else {
                    window.globalThis.dataLayer.push({ 'product': 'movilidad', 'event': 'errorServidor', 'paso': 'cotizador-movilidad-venta-completa' });
                }
            });
            //---------------------------------------------------------------------
        }
    });
